import React from 'react';

interface PlacesIconProps {
  isActive: boolean;
  color?: string;
}

export function PlacesIcon({
  isActive = false,
  color,
}: PlacesIconProps) {
  return isActive ? getActiveIcon(color) : getInActiveIcon(color);
}

function getActiveIcon(color?: string) {
  const currentColor = color || "#000000";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ color: currentColor }}>
      <path
        d="M12 2C7.58 2 4 5.58 4 10C4 15.5 12 22 12 22C12 22 20 15.5 20 10C20 5.58 16.42 2 12 2Z"
        fill={currentColor}
      />
      <circle cx="12" cy="10" r="2.75" fill="white" />
    </svg>
  );
}

function getInActiveIcon(color?: string) {
  const currentColor = color || "#B0B0B0";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ color: currentColor }}>
      <path
        d="M20 10C20 15.5 12 22 12 22C12 22 4 15.5 4 10C4 5.58 7.58 2 12 2C16.42 2 20 5.58 20 10Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="10"
        r="2.75"
        stroke={currentColor}
        strokeWidth="1.5"
      />
    </svg>
  );
}
